import { FiAlignLeft, FiAlignCenter, FiAlignRight } from 'react-icons/fi';

import { Combobox, UnstyledButton, useCombobox } from '@any-ui-react/core';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import classNames from 'classnames';

import { Alignment, SELECT_ALIGNMENT } from './AlignmentPlugin';

const alignments: Alignment[] = ['start', 'center', 'end'];

const iconProps = { className: 'w-6 h-6 text-gray-7' };

const icons: Record<Alignment, React.ReactNode> = {
  start: <FiAlignLeft {...iconProps} />,
  center: <FiAlignCenter {...iconProps} />,
  end: <FiAlignRight {...iconProps} />,
};

export const AlignmentSelect = ({ alignment }: { alignment: Alignment }) => {
  const [editor] = useLexicalComposerContext();
  const combobox = useCombobox();

  return (
    <Combobox
      store={combobox}
      onOptionSubmit={(alignment) => {
        editor.dispatchCommand(SELECT_ALIGNMENT, { alignment: alignment as Alignment });
        editor.focus();
        combobox.closeDropdown();
      }}
    >
      <Combobox.Target>
        <UnstyledButton
          className={classNames('flex w-12 items-center justify-center gap-px', {
            'bg-gray-2': combobox.dropdownOpened,
          })}
          onClick={() => {
            combobox.toggleDropdown();
          }}
        >
          {icons[alignment]}
          <Combobox.Chevron />
        </UnstyledButton>
      </Combobox.Target>

      <Combobox.Dropdown className="border-none bg-transparent p-0">
        <Combobox.Options className="flex w-fit flex-row gap-x-1 border bg-white p-1">
          {alignments.map((value) => (
            <Combobox.Option
              value={value}
              key={value}
              className={classNames('p-1', {
                'bg-gray-2!': value === alignment,
              })}
            >
              {icons[value]}
            </Combobox.Option>
          ))}
        </Combobox.Options>
      </Combobox.Dropdown>
    </Combobox>
  );
};
